import { render, staticRenderFns } from "./_groups.vue?vue&type=template&id=642f9aaa&scoped=true&"
import script from "./_groups.vue?vue&type=script&lang=js&"
export * from "./_groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f9aaa",
  null
  
)

export default component.exports